import * as React from 'react'

function IconVariantLeaf(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={36}
      height={30}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.064 29.498L29.096 6.562 0 27.052S3.676-5.5 36 .813c0 0-.06 33.66-28.936 28.686z"
        fill="#F4BA27"
      />
    </svg>
  )
}

export default IconVariantLeaf
